<template>
    <div>
        <template v-if="! orderIsLoaded()">
            <sau-loading>
                <template slot="message">Fetching Order</template>
            </sau-loading>
        </template>
        <template v-else>
            <template v-if="order.items.length">
                <div class="text-xl flex content-center mb-8">
                    <div class="flex-1">
                        <!-- <i class="fal fa-shopping-cart text-grey-700 mr-1"></i> -->
                        Your Cart
                    </div>

                    <div>
                        <router-link
                            to="/order"
                            class="text-sm"
                            v-if="this.$route.path !== '/order'"
                        >
                            <i class="fal fa-plus mr-1"></i>Add More
                        </router-link>
                    </div>
                </div>
                <div
                    :key="index"
                    class="-mx-3 px-3 -mt-3 mb-3 py-3 relative border border-white"
                    v-for="(item, index) in order.items"
                    :class="{
                        'bg-green-100 border-green-300': itemIsSelected(item),
                    }"
                >
                    <h6 v-if="itemIsSelected(item)"
                        class="uppercase tracking-wider text-2xs text-green mb-0 absolute right-0 mr-3"
                    >
                        Editing
                    </h6>
                    <template v-else>
                        <button
                            v-if="! item.processing && typeIsEditable(item.type)"
                            @click.prevent="editItem(item)"
                            class="uppercase tracking-wider text-2xs text-blue mb-0 absolute right-0 mr-3"
                        >
                            Edit
                        </button>
                    </template>

                    <div class="flex" style="min-height: 4rem;">
                        <div class="flex-1">
                            <h6 class="uppercase tracking-wider text-2xs text-grey mb-0" v-if="item.type.toLowerCase() == 'vps'">CLOUD</h6>
                            <h6 class="uppercase tracking-wider text-2xs text-grey mb-0" v-else>{{ item.type | Ucwords }}</h6>

                            <template v-if="item.type === 'dedicated-server'">
                                <!-- <div class="break-words text-sm" v-if="item.slug"> -->
                                    <!-- Server ID: {{ item.slug }} -->
                                <!-- </div> -->
                                <div class="break-words text-sm">
                                    <template v-if="item.processing">
                                        &nbsp;
                                    </template>
                                    <template v-else>
                                        {{ item.hostname ? item.hostname : 'Dedicated Server' }}
                                    </template>
                                </div>
                                <div class="break-words text-2xs uppercase tracking-wider text-grey-600">
                                    <template v-if="item.processing">
                                        &nbsp;
                                    </template>

                                    <template v-else>
                                        OS: {{ item.os ? (item.os.description ? item.os.description : 'N/A') : 'N/A' }}
                                        <br />
                                        CPU: {{ item.cpu ? (item.cpu.description ? item.cpu.description : 'N/A') : 'N/A' }}
                                        <br />
                                        RAM: {{ item.ram ? (item.ram.description ? item.ram.description : 'N/A') : 'N/A' }}
                                        <br />
                                        Bandwidth: {{ item.bandwidth ? (item.bandwidth.description ? item.bandwidth.description : 'N/A') : 'N/A' }}
                                        <br />
                                        Location: {{ item.location ? (item.location.description ? item.location.description : 'N/A') : 'N/A' }}
                                        <br />
                                        <template v-if="item.storage && item.storage.length">
                                            Storage: <span v-for="(disk, index) in item.storage" :key="index">{{ disk.description }} </span>
                                        </template>
                                        <template v-else>
                                            Storage: N/A
                                        </template>
                                        <br />
                                        <template v-if="item.addons && item.addons.backup_frequency">
                                            Backup Frequency: {{ item.addons.backup_frequency.name }}
                                            <br />
                                        </template>
                                        <template v-if="item.addons && item.addons.backup_storage">
                                            Backup Storage: {{ item.addons.backup_storage.name }}
                                            <br />
                                        </template>
                                        <template v-if="item.addons && item.addons.additional_ips">
                                            Additional IP's: {{ item.addons.additional_ips.name }}
                                            <br />
                                        </template>
                                        <template v-if="item.addons && item.addons.windows_server_licence">
                                            {{ item.addons.windows_server_licence.name }}
                                            <br />
                                        </template>
                                        <template v-if="item.licence && item.licence.description">
                                            Licence: {{ item.licence.description }}
                                            <br />
                                        </template>

                                    </template>
                                </div>
                            </template>

                            <template v-if="item.type === 'domain'">
                                <div class="break-words text-sm" style="word-break: break-all;">
                                    <template v-if="item.domain">
                                        {{ item.domain }}
                                    </template>
                                    <template v-else>
                                        &nbsp;
                                    </template>
                                </div>
                                <div class="break-words text-2xs uppercase tracking-wider text-grey-600">
                                    <template v-if="item.registration_period">
                                        {{ item.registration_period }} Years
                                    </template>
                                    <template v-else>
                                        &nbsp;
                                    </template>
                                </div>
                            </template>


                            <template v-if="item.type === 'domain-transfer' || item.type === 'domain-renewal'">
                                <div class="break-words text-sm" style="word-break: break-all;">
                                    <template v-if="item.domain">
                                        {{ item.domain }}
                                    </template>
                                    <template v-else>
                                        &nbsp;
                                    </template>
                                </div>
                                <div class="break-words text-2xs uppercase tracking-wider text-grey-600">
                                    <template v-if="item.registration_period">
                                        {{ item.registration_period }} Years
                                    </template>
                                    <template v-else>
                                        &nbsp;
                                    </template>
                                </div>
                            </template>


                            <template v-if="item.type === 'managed-wordpress'">
                                <div class="break-words text-sm" style="word-break: break-all;">
                                    <template v-if="item.package">
                                        {{ item.package.replace('Managed WordPress ', '') }}
                                    </template>
                                    <template v-else>
                                        &nbsp;
                                    </template>
                                </div>
                                <div class="break-words text-2xs uppercase tracking-wider text-grey-600">
                                    <template v-if="item.domain">
                                        Domain: {{ item.domain ? item.domain : 'N/A' }}
                                    </template>
                                    <template v-else>
                                        &nbsp;
                                    </template>
                                </div>
                            </template>

                            <template v-if="item.type === 'vps'">
                                <div class="break-words text-sm" style="word-break: break-all;">
                                    <template v-if="item.processing">
                                        &nbsp;
                                    </template>
                                    <template v-else>
                                        Cloud Server
                                    </template>
                                </div>
                                <div class="break-words text-2xs uppercase tracking-wider text-grey-600">
                                    <template v-if="item.processing">
                                        &nbsp;
                                    </template>
                                    <template v-else>
                                        <span v-html="item.description"></span><br />
                                        <span>OS: {{ item.os && item.os.name ? item.os.name : 'N/A' }}</span><br />
                                        <span>IP: {{ item.ips && item.ips.name ? item.ips.name : 'N/A' }}</span><br />
                                        <template v-if="item.hostname"><span>Hostname: {{ item.hostname }}</span><br /></template>
                                        <span>Licence: {{ item.licence && item.licence.description ? item.licence.description : 'None' }}</span>
                                    </template>
                                </div>
                            </template>

                            <template v-if="item.type === 'mega-bundle'">
                                <div class="break-words text-sm" style="word-break: break-all;">
                                    <template v-if="item.processing">
                                        &nbsp;
                                    </template>
                                    <template v-else>
                                        Mega Bundle
                                    </template>
                                </div>
                                <div class="break-words text-2xs uppercase tracking-wider text-grey-600">
                                    <template v-if="item.processing">
                                        &nbsp;
                                    </template>
                                    <template v-else>
                                        <span>CPU: {{ item.package && item.package.cpu ? item.package.cpu : 'N/A' }}</span><br />
                                        <span>RAM: {{ item.package && item.package.ram ? item.package.ram : 'N/A' }}</span><br />
                                        <span>Storage: {{ item.package && item.package.storage ? item.package.storage : 'N/A' }}</span><br />
                                        <span>Backups: {{ item.package && item.package.backup ? item.package.backup : 'N/A' }}</span><br />
                                        <span>Bandwidth: {{ item.package && item.package.bandwidth ? item.package.bandwidth : 'N/A' }}</span><br />
                                        <span>Bundle: {{ item.option && item.option.name ? item.option.name : 'N/A' }}</span><br />
                                        <span>Location: {{ item.option && item.option.location ? item.option.location : 'N/A' }}</span><br />
                                        <span>Monitoring: {{ item.option && item.option.monitoring ? item.option.monitoring : 'N/A' }}</span><br />
                                        <span>Software: {{ item.option && item.option.software ? item.option.software : 'N/A' }}</span><br />
                                    </template>
                                </div>
                            </template>

                            <template v-if="item.type === 'colocation'">
                                <div class="break-words text-sm" style="word-break: break-all;">
                                    <template v-if="item.processing">
                                        &nbsp;
                                    </template>
                                    <template v-else>
                                        Colocation
                                    </template>
                                </div>
                                <div class="break-words text-2xs uppercase tracking-wider text-grey-600">
                                    <template v-if="item.processing">
                                        &nbsp;
                                    </template>
                                    <template v-else>
                                        Data Centre:
                                            <span v-if="item.dc_location && item.dc_location.name">{{ item.dc_location.name }}</span>
                                            <span v-else><i class="far fa-spinner-third fa-spin"></i></span><br />
                                        Allocation:
                                            <span v-if="item.allocation && item.allocation.title">{{ item.allocation.title }}</span>
                                            <span v-else><i class="far fa-spinner-third fa-spin"></i></span>
                                    </template>
                                </div>
                            </template>

                            <template v-if="item.type === 'ssl-certificate'">
                                <div class="break-words text-sm" style="word-break: break-all;">
                                    <template v-if="item.domain">
                                        {{ item.domain }}
                                    </template>
                                    <template v-else>
                                        {{ data.config.products.sslcertificate.find(p => p.id == item.product_id).name }}
                                    </template>
                                </div>
                                <div class="break-words text-2xs uppercase tracking-wide text-grey-600">
                                    <template v-if="item.billing_cycle_years">
                                        {{ item.billing_cycle_years }} {{ item.billing_cycle_years == 1 ? 'Year' : 'Years' }}
                                    </template>
                                    <template v-else>
                                        &nbsp;
                                    </template>
                                </div>
                            </template>
                        </div>

                        <div class="self-center text-xs sm:text-sm text-grey-600 pl-2">
                            <template v-if="item.price">
                                {{ item.price.rrp | currency }}
                            </template>
                            <template v-else>
                                &nbsp;
                            </template>
                        </div>

                        <div class="self-center relative" style="width: 2rem; height: 2rem;">
                            <i v-if="item.processing" class="far fa-spinner-third fa-spin text-grey-600 ml-2 p-2 -mr-2" style="position: absolute; top: 0; left: 0;"></i>
                            <template v-else>
                                <button @click.prevent="removeItem(item)" style="position: absolute; top: 0; left: 0;" class="focus-0">
                                    <i class="far fa-times text-grey-600 hover:text-red ml-2 p-2 -mr-2"></i>
                                </button>
                            </template>
                        </div>
                    </div>
                </div>

                <div class="border-t pt-3">
                    <p class="text-sm w-full mb-1">
                        Sub Total
                        <span class="float-right">{{ order.subtotal | currency }}</span>
                    </p>
                    <p class="text-sm w-full mb-1" v-if="getUsersAppliedTaxName">
                        +{{ getUsersAppliedTaxRate }}% {{ getUsersAppliedTaxName }}
                        <span class="float-right">{{ order.tax | currency }}</span>
                    </p>
                    <p class="text-xl w-full mb-0 sau-font-bold">
                        Total
                        <template v-if="order.total">
                            <span class="float-right">{{ order.total | currency }}</span>
                        </template>
                    </p>
                </div>

                <div class="mt-3">
                    <button @click.prevent="goToNextStep()" class="btn btn-success d-block w-100" :disabled="processing || hasPendingItems()">
                        <template v-if="processing || hasPendingItems()">
                            Please wait...
                        </template>
                        <template v-else>
                            {{ shouldConfirmDomains ? 'Next Step' : 'Review Order' }}
                        </template>
                    </button>
                </div>
            </template>

            <div v-else class="m-0 text-sm text-center text-grey-700">
                There are no items in your cart.
                <!-- Add link to add products -->
                <div class="mt-4">
                    <router-link
                        to="/order"
                        class="text-sm"
                        v-if="this.$route.path !== '/order'"
                    >
                        Back to products
                    </router-link>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        data: Object,
        order: Object,
    },

    data() {
        return {
            processing: false,
        };
    },

    computed: {
        window() {
            return window;
        },

        shouldConfirmDomains() {
            let thereAreDomainsInTheOrder = !! this.order.items.filter(
                item => item.type === 'domain'
            ).length;
            let domainsHaveQuestions = !! this.order.items.filter(
                item => item.questions && item.type === 'domain'
            ).length;

            return thereAreDomainsInTheOrder
                && domainsHaveQuestions
                && this.confirmingDomains() === false;
        },

        nextStep() {
            return this.shouldConfirmDomains ? '/order/confirm-domains' : '/order/view';
        },

    },

    methods: {
        orderIsLoaded() {
            return window.store.orders.loaded;
        },

        hasPendingItems() {
            return this.order.items.filter(item => item.slug.startsWith('temp-')).length > 0;
        },

        buyingDomains() {
            return this.$route.path === '/order/domain'
                || this.$route.path === '/order/domain/register';
        },

        buyingSsl() {
            return this.$route.path.startsWith('/order/ssl');
        },

        confirmingDomains() {
            return this.$route.path.startsWith('/order/confirm-domains');
        },

        itemIsSelected(item) {
            if (item.type === 'managed-wordpress') {
                return this.data.active.managedWordpress === item.slug;
            }

            if (item.type === 'dedicated-server') {
                return this.data.active.dedicatedServer === item.slug;
            }

            if (item.type === 'vps') {
                return this.data.active.vps === item.slug;
            }

            if(item.type == 'mega-bundle') {
                return this.data.active.megaBundle == item.slug;
            }

            if (item.type === 'ssl-certificate') {
                return this.data.active.sslCertificate === item.slug;
            }

            return false;
        },

        typeIsEditable(type) {
            let notEditable = [
                'domain',
                'colocation',
                'domain-transfer',
                'domain-renewal'
            ];
            return ! notEditable.includes(type);
        },

        editItem(item) {
            this.showConfirmationIfNeededAndRunIfOk(() => {
                window.bus.$emit('order.items.edit', item);
            });
        },

        removeItem(item) {
            let callback = () => {
                if (this.buyingDomains() && item.domain && item.type === 'domain') {
                    // this.$emit('remove-domain', item.domain);
                    window.bus.$emit('remove-domain', item.domain); // use global event bus
                    return;
                }

                window.bus.$emit('order.items.delete', item);

                if (this.itemIsSelected(item)) {
                    this.$router.push('/order');
                }
            };

            return this.itemIsSelected(item)
                ? callback()
                : this.showConfirmationIfNeededAndRunIfOk(callback);
        },

        goToNextStep() {
            this.showConfirmationIfNeededAndRunIfOk(() => {
                window.bus.$emit('clear-domain-suggestions');
                this.$router.push(this.nextStep);
            });
        },

        saveAllDomainsQuestions() {
            return new Promise(resolve => {
                let failures = 0;
                let processed = 0;

                let domains = this.order.items.filter(
                    item => item.questions && item.type === 'domain'
                );

                domains.forEach(domain => {
                    this.saveQuestionsForDomain(domain, error => {
                        if (error.response.status < 200 || error.response.status > 299) {
                            failures++;
                        }
                    }).finally(response => {
                        processed++;
                        if (processed === domains.length) {
                            resolve(failures === 0);
                        }
                    });
                });
            });
        },

        saveQuestionsForDomain(domain, onCatch = null) {
            // We need to call this.$parent for the form data.
            if (! this.confirmingDomains()) {
                return;
            }

            let formData = {};
            let form = this.$parent.$refs[domain.slug][0];
            for (var i = 0; i < form.elements.length; i++) {
                formData[form.elements[i].name] = form.elements[i].value;
            }

            this.$emit('clear-domain-errors', domain.slug);

            return window.axios.patch(`/api/orders/${this.order.slug}/domain-confirmations/${domain.slug}`, formData)
                .then(() => {
                    window.bus.$emit('order.refresh');
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        this.$emit('domain-errors', domain.slug, error.response.data.errors);
                    }

                    if (onCatch) {
                        onCatch(error);
                    }
                });
        },

        showConfirmationIfNeededAndRunIfOk(callback) {
            if (this.processing) {
                return;
            }

            this.processing = true;

            if (this.confirmingDomains()) {
                this.saveAllDomainsQuestions().then(success => {
                    this.processing = false;

                    if (success) {
                        return callback();
                    }

                    this.$swal({
                        type: 'warning',
                        html: `
                            <p>There are issues with your input. If you continue, you may lose your changes.</p>
                            <p>Are you sure you want to continue?</p>
                        `,
                        showConfirmButton: true,
                        confirmButtonText: 'Continue',
                        confirmButtonClass: 'bg-red text-red-100',
                        cancelButtonClass: 'bg-white text-grey-900',
                        showCancelButton: true,
                        preConfirm: callback,
                    });
                });

                return;
            }

            if (this.managedWordpressSelected()) {
                window.bus.$once('order-item-valid', item => {
                    this.processing = false;
                    callback()
                });
                window.bus.$once('order-item-invalid', item => {
                    this.processing = false;
                    this.$swal({
                        type: 'warning',
                        html: `
                            <p>There are issues with your input. You must fix your input to be able to submit an order.</p>
                            <p>Are you sure you want to continue?</p>
                        `,
                        showConfirmButton: true,
                        confirmButtonText: 'Continue',
                        confirmButtonClass: 'bg-red text-red-100',
                        cancelButtonClass: 'bg-white text-grey-900',
                        showCancelButton: true,
                        preConfirm: callback,
                    });
                });

                window.bus.$emit(
                    'validate-order-item', this.order.items.find( item => this.itemIsSelected(item) )
                );

                return;
            }

            callback();
            this.processing = false;
        },

        managedWordpressSelected() {
            return !! this.order.items.find(
                item => this.itemIsSelected(item) && item.type === 'managed-wordpress'
            );
        },
    },

    watch: {
        order(val) {
            if (this.orderIsLoaded() && this.order.items.length === 0 && (
                this.$route.path.startsWith('/order/view')
                || this.$route.path.startsWith('/order/confirm-domains')
                || this.$route.path.startsWith('/order/dedicated-server/custom')
            )) {
                this.$router.push(`/order`);
            }

            this.$nextTick(() => {
                window.jQuery(window).trigger('resize');
            });
        },
    },
}
</script>
